const hideWhenSiteIsFIT = variables => variables.selectedSites?.every(site => site.contract_id.includes("FIT"));
const hideWhenSelectedCountryIsNotAll = variables => variables.selectedCountry !== 'ALL'
const hideWhenSiteIsSolo = variables => variables.selectedSites?.every(site => site.solo);
const hideWhenClientAndSiteIsSolo = variables => variables.user?.roles?.includes("_CLIENT:Base") && variables.selectedSites?.every(site => site.solo);
const hideAllUsersExceptVN_OM = variables => !variables.user?.roles?.includes("administration:DataDownload:dailyIncidences:_view");
const hideWhenSiteIsNotBESS = variables => !variables.selectedSites?.some(site => site.is_BESS);

export default {
	hideWhenSiteIsFIT,
	hideWhenSelectedCountryIsNotAll,
	hideWhenSiteIsSolo,
	hideWhenClientAndSiteIsSolo,
	hideAllUsersExceptVN_OM,
	hideWhenSiteIsNotBESS,
};